const o = {
  Email: "EMAIL",
  Phone: "PHONE"
};
export {
  o as r
};
//# sourceMappingURL=UsernameContactType-4e10a9dc.mjs.map
